import React, { useState, useEffect } from 'react';
import { cn } from '../lib/utils';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

function getInitials(name) {
  if (!name) return 'U';
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return parts[0][0]?.toUpperCase() || 'U';
}

const SIZE_MAP = {
  xs: { container: 'w-6 h-6', text: 'text-[10px]' },
  sm: { container: 'w-8 h-8', text: 'text-xs' },
  md: { container: 'w-10 h-10', text: 'text-sm' },
  lg: { container: 'w-14 h-14', text: 'text-lg' },
  xl: { container: 'w-20 h-20', text: 'text-2xl' },
};

const COLOR_PALETTE = [
  'bg-blue-600', 'bg-emerald-600', 'bg-violet-600', 'bg-rose-600',
  'bg-amber-600', 'bg-teal-600', 'bg-indigo-600', 'bg-pink-600',
];

function hashColor(name) {
  if (!name) return COLOR_PALETTE[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return COLOR_PALETTE[Math.abs(hash) % COLOR_PALETTE.length];
}

export const UserAvatar = ({ name, avatarUrl, size = 'md', className }) => {
  const [imgError, setImgError] = useState(false);
  const sizeInfo = SIZE_MAP[size] || SIZE_MAP.md;
  const initials = getInitials(name);
  const bgColor = hashColor(name);
  // Add cache-bust param that changes only when the URL changes
  const fullUrl = avatarUrl ? `${API_BASE}${avatarUrl}` : null;
  const showImage = fullUrl && !imgError;

  // Reset error state when avatarUrl changes (e.g. after new upload)
  useEffect(() => {
    setImgError(false);
  }, [avatarUrl]);

  return (
    <div
      className={cn(
        sizeInfo.container,
        'relative rounded-full overflow-hidden flex-shrink-0',
        !showImage && bgColor,
        className
      )}
      data-testid="user-avatar"
    >
      {showImage ? (
        <img
          src={fullUrl}
          alt={name || 'Avatar'}
          className="w-full h-full object-cover"
          onError={() => setImgError(true)}
        />
      ) : (
        <div className={cn(
          'w-full h-full flex items-center justify-center text-white font-semibold',
          sizeInfo.text
        )}>
          {initials}
        </div>
      )}
    </div>
  );
};

export default UserAvatar;
